/**
 * Density is set once on <html> and read by the tokens (design §2.2). A
 * component never chooses its own density; it reads `--gf-row-y` and friends.
 */
export type Density = 'compact' | 'comfortable'

export function setDensity(density: Density): void {
  document.documentElement.dataset.density = density
}

/**
 * Coarse pointer => touch => `comfortable`. Deliberately a POINTER query and
 * not a width query: a small desktop window is still a mouse, and a large
 * tablet on a site is still a gloved finger.
 */
export function preferredDensity(): Density {
  return window.matchMedia('(pointer: coarse)').matches ? 'comfortable' : 'compact'
}
